const state = {
  items: [],
  actives: [],
  triggers: []
}

export default state
